<template>
    <b-card header="create">
      <!-- for loading page -->
      <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
        <div slot="header">
          <i class="icon-note" aria-hidden="true"></i>
            New Document
            <div class="card-header-actions">
            <router-link :to="'/docs/home'" class="card-header-action" rel="noreferrer noopener">
              <small class="text-muted">docs</small>
            </router-link>
          </div>
        </div>
    <b-row>
        <b-col sm="12">
          <!-- Alert -->
          <alert-success :show="isSuccess" :redirectName="'docs-home'">Create new document success. </alert-success>
          <alert-fail :show="isError">{{ messageError }}</alert-fail>
            <!-- Topic -->
            <b-form-group>
            <label for="sendTo">Topic</label>
                <b-input-group>
                    <b-input
                        :state="isMaxLengthTopic"
                        v-model="form.topic"
                        placeholder="Please enter topic"
                        >
                    </b-input>
                    <b-form-invalid-feedback>
                    Max length is 15 letters.
                  </b-form-invalid-feedback>
                </b-input-group>
            </b-form-group>

            <!-- Topic -->
            <b-form-group>
            <label for="sendTo">Type</label>
                <b-input-group>
                    <b-form-select @change="getData" v-model="form.type" :options="typeOptions"></b-form-select>
                </b-input-group>
            </b-form-group>

            <!-- Content -->
            <b-form-group>
            <label for="sendTo">Content</label>
                    <div id="editor">
                    </div>
            </b-form-group>
        </b-col>
    </b-row>
     <div slot="footer">
          <b-button @click="$router.go(-1)" class="mr-2" size="sm" variant="secondary">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            Back
          </b-button>
          <b-button :disabled="!isActive" @click="saveDocument" class="mr-2" type="submit" size="sm" variant="primary">
            <i class="fa fa-dot-circle-o"></i>
            Save
          </b-button>
        </div>
    </b-card>
</template>

<script>
import { CustomUploadAdapterPlugin } from '../../assets/utils/editor-upload';
import InlineEditor from '@ckeditor/ckeditor5-build-inline/build/ckeditor';
import Loading from '../../components/Loading';
import AlertSuccess from '../../components/alert/AlertSuccess';
import AlertFail from '../../components/alert/AlertFail';

export default {
  data () {
    return {
      form: {
        topic: '',
        content: '',
        type: 'architecture'
      },
      typeOptions: {
        architecture: 'Architecture',
        deployment: 'Deployment',
        api: 'Sequence & API',
        installation: 'Installation',
        toturial: 'Tutorials'
      },
      isActive: true,
      isLoading: false,
      isError: false,
      isSuccess: false,
      messageError: 'Error'
    };
  },
  methods: {
    getData () {
      console.log(this.editor.getData());
    },
    saveDocument () {
      this.isActive = false;
      this.isLoading = true;
      this.form.content = this.editor.getData();

      this.axios.post(process.env.VUE_APP_URL_DOCS_API + '/docs', this.form)
        .then(response => {
          this.handelSuccess();
        })
        .catch(error => {
          console.log(error.response);
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    createEditor (id) {
      InlineEditor
        .create(document.querySelector(id), {
          extraPlugins: [CustomUploadAdapterPlugin],
          placeholder: 'Content of the editor.',
          image: {
            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
            styles: [
              'full',
              'alignLeft',
              'alignRight'
            ]
          },
          uploadUrl: process.env.VUE_APP_URL_DOCS_API + '/docs/upload' // custom plugin
        })
        .then(newEditor => {
          this.editor = newEditor;
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    handleError (error) {
      const message = error.response.data.data || null;
      if (message) {
        Array.isArray(message)
          ? error.response = message.map(data => data.msg).join(', ')
          : error.response = message;
      }
      this.messageError = error.response || error.message;
      this.isError = true;
      this.isActive = true;
    },
    handelSuccess () {
      this.isLoading = false;
      this.isSuccess = true;
    }
  },
  components: {
    'app-loading': Loading,
    AlertSuccess,
    AlertFail
  },
  computed: {
    isMaxLengthTopic () {
      return this.form.topic.length <= 15 ? null : false;
    }
  },
  mounted () {
    this.createEditor('#editor');
  },
  watch: {
    'form.topic' () {
      false === this.isMaxLengthTopic ? this.isActive = false : this.isActive = true;
    }
  },
  destroyed () {
    this.editor.destroy(); // protect alert error rect-source-not-in-dom
  }
};
</script>

<style scoped>
    .ck-content {
        min-height:200px;
        border: 1px solid #CCCCCC;
    }
</style>
